import { useTranslation } from 'react-i18next';

import { FilledButton } from 'libs/ui';
import { Content } from './add.styled';

export const ReceiptAdd = (props) => {
  const { t } = useTranslation();

  return (
    <Content>
      <FilledButton className="size-sm" color="success" onClick={props.addNew} disabled={props.show}>
        {t('buttons.Новый шаблон')}
      </FilledButton>
    </Content>
  );
};
